/**
 * Lookups into the publication's table of contents tree.
 *
 * Paged formats match printed pages while walking nested `items`
 * in reading order. EPUB resolution lives with the Readium viewer.
 */

// Every entry in reading order, each parent ahead of its own children.
const flattenTocItems = items =>
    (Array.isArray(items) ? items : []).flatMap(item => [item, ...flattenTocItems(item.items)]);

/**
 * Returns the entry the reader is inside: the last entry in
 * reading order that starts at or before the given page.
 */
export const findTocItemByPage = (items, page) => {
    if (!Number.isFinite(page)) {
        return null;
    }

    // flattenTocItems builds a new array, so reversing it in place touches nothing else.
    const entriesFromLast = flattenTocItems(items).reverse();

    // `?? NaN` keeps unpaged entries out: Number(null) would be 0 and match every page.
    return entriesFromLast.find(entry => Number(entry.page ?? NaN) <= page) ?? null;
};
